import styled from 'styled-components';

export const CalendarInviteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`;

export const InviteCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  width: 100%;
`;

export const InviteTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const InviteText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: rgb(100, 116, 139);
  margin: 0 0 8px 0;
  line-height: 1.6;
  letter-spacing: 0.025em;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 16px;
  }

  .invite-text-break-line {
    display: none;
  }

  @media (max-width: 768px) {
    .invite-text-break-line {
      display: block;
    }
  }
`;

export const InviteButton = styled.button<{ $isSuccess?: boolean }>`
  background-color: ${(props: { $isSuccess?: boolean }) =>
    props.$isSuccess ? '#A5B4FC' : '#4F46E5'};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 56px;
`;

export const ErrorMessage = styled.div`
  background: #fed7d7;
  color: #c53030;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const ErrorIcon = styled.svg`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
